<template functional>
  <v-data-table
    v-bind="data.attrs"
    v-on="data.on"
    :footer-props="{
      showFirstLastPage: true
    }"
    dense
    :class="[data.class, data.staticClass, 'admin-table']">
    <template v-slot:no-data>
      <v-alert :value="true" color="error" icon="mdi-warning" v-show="!data.attrs.loading">
        Sorry, no items were found.
      </v-alert>
    </template>
    <template #item="slotProps">
      <slot name="item" v-bind="slotProps"></slot>
    </template>
  </v-data-table>
</template>

<script>
import Vue from "vue"
import { VDataTable, VAlert } from 'vuetify/lib'
Vue.component("v-data-table", VDataTable)
Vue.component("v-alert", VAlert)
export default {}
</script>

<style>
  .admin-table table.v-table thead tr {
    height: 40px;
  }

  .admin-table .v-table tbody td, 
  .admin-table .v-table thead th {
    height: 36px;
    padding: 0 20px !important;
  }

  .admin-table .v-data-footer {
    padding: 0 20px;
  }
</style>
